var StoreList = {
  map: null,
  keyword: null,
  markers: [],
  stores: [],
  $liStores: null,
  $ulStoreList: null,

  init: function (jsonUrl, map, cb) {
    StoreList.map = map;
    StoreList.keyword = StoreList.getQueryString('keyword');

    $.ajax({
      url: jsonUrl,
      type: 'GET'
    }).done(function (stores) {
      StoreList.stores = stores;
      StoreList.setPanel();
      StoreList.setMarkers();
      cb();
    }).fail(function (xhr, err, status) {
      alert('店舗情報の取得に失敗しました。お手数ですが時間をあけて再度お試しください。');
    });
  },

  setPanel: function () {
    var list = '';

    StoreList.stores.forEach(function (store) {
      var divStoreId = '<div class="store-id-wrapper"><span class="store-id">' + store.id + '</span></div>';
      var div = divStoreId + '<div class="shop-info"><div class="title">' + store.name + '</div><div id="store-address-' + store.id + '" class="store-address">' + store.address + '</div><div class="store-tel">' + store.tel + '</div><div class="store-open">営業時間：<br>' + store.open + '</div></div>';
      var li = '<li id="store-' + store.id + '" class="store li-store" data-store-id="' + store.id + '" data-store-lat="' + store.lat + '" data-store-lng="' + store.lng + '">' + div + '</li>';

      list += li;
    });

    StoreList.$ulStoreList.append(list);
    StoreList.$liStores = $('.li-store');
    StoreList.$liStores.on('click', function () {
      var $that = $(this),
          storeId = $that.data('storeId');

      StoreList.$liStores.removeClass('selected');
      $that.addClass('selected');

      StoreList.map.setCenter(new google.maps.LatLng(
        $that.data('storeLat'),
        $that.data('storeLng')
      ));

      new google.maps.event.trigger(StoreList.markers[storeId], 'click');
    });
  },

  setMarkers: function () {
    StoreList.stores.forEach(function (store) {
      var cls = 'rich-marker';

      if (store.id.length < 2) {
        cls += ' rich1';
      } else if (store.id.length < 3) {
        cls += ' rich2';
      } else {
        cls += ' rich3';
      }

      var marker = new RichMarker({
        position: new google.maps.LatLng(store.lat, store.lng),
        shadow: 'none',
        content: '<div id="rich-marker-' + store.id + '" class="' + cls + '"><span class="rich-marker-store-id">' + store.id + '</span></div>',
        map: StoreList.map
      });

      marker.setValues({store_id: store.id});

      StoreList.setMarkerEvent(marker);

      StoreList.markers[store.id] = marker;
    });
  },

  setMarkerEvent: function (marker) {
    // markerにイベントを登録する
    google.maps.event.addListener(marker, 'click', function () {

      // panel
      StoreList.$liStores.removeClass('selected');
      var $store = $('#store-' + this.store_id);
      $store.addClass('selected');
      location.hash = 'store-' + this.store_id;

      if ('scrollingElement' in document) {
        var scrollableElement = document.scrollingElement;
      } else if (/*@cc_on!@*/false || (!!window.MSInputMethodContext && !!document.documentMode)) {
        var scrollableElement = document.documentElement;
      } else if (firefox && parseInt(firefox[1]) <= 47) {
        var scrollableElement = document.documentElement;
      } else {
        var scrollableElement = document.body;
      }

      scrollableElement.scrollTop = $('#map').offset().top - 30;      
      
       // marker
      $('.rich-marker').removeClass('selected');
      $('#rich-marker-' + this.store_id).addClass('selected');

      // map
      StoreList.map.setZoom(15);
      StoreList.map.panTo(this.getPosition());
    });;
  },

  showAllStores: function () {
    StoreList.$liStores.removeClass('hidden');

    StoreList.markers.forEach(function (marker) {
      marker.setVisible(true);
    });
  },

  hideAllStores: function () {
    StoreList.$liStores.addClass('hidden');

    StoreList.markers.forEach(function (marker) {
      marker.setVisible(false);
    })
  },

  toggleStores: function (word) {
    StoreList.hideAllStores();

    var first = true;

    StoreList.stores.forEach(function (store) {
      var lowerName = store.name.toLowerCase();
      var lowerWord = word.toLowerCase();
      var match = false;

      // 名称に含むか
      if (lowerName.indexOf(lowerWord) !== -1) {
        $('#store-' + store.id).removeClass('hidden');
        StoreList.markers[store.id].setVisible(true);

        if (first) {
          new google.maps.event.trigger(StoreList.markers[store.id], 'click');
          first = false;
        }

        return true;
      }

      // 住所に含むか
      if (store.address.indexOf(lowerWord) !== -1) {
        $('#store-' + store.id).removeClass('hidden');
        StoreList.markers[store.id].setVisible(true);

        if (first) {
          new google.maps.event.trigger(StoreList.markers[store.id], 'click');
          first = false;
        }

        return true;
      }

      // キーワードに含むか
      var tmp = store.keywords.split(',');
      tmp.forEach(function (keyword) {
        if (keyword === word) {
          $('#store-' + store.id).removeClass('hidden');
          StoreList.markers[store.id].setVisible(true);

          if (first) {
            new google.maps.event.trigger(StoreList.markers[store.id], 'click');
            first = false;
          }

          return false;
        }
      });
    });
  },
  
  getQueryString: function (name, url) {
    if (!url) {
      url = window.location.href;
    }

    name = name.replace(/[\[\]]/g, "\\$&");

    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);

    if (!results) {
      return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  
};
